import { IAreaGraph } from '@/types/explorer';

const getIntegerTicksForAreaChart = (data: IAreaGraph[]) => {
  return Array.from(
    new Set(
      data
        .filter((graphValue: IAreaGraph) => Number.isInteger(graphValue.value))
        .map((graphValue: IAreaGraph) => graphValue.value || ''),
    ),
  );
};

export { getIntegerTicksForAreaChart };
